import styled from "styled-components";

export const TransferRequirementsWrapper = styled.div`
  display: flex;
  gap: 49px;
  justify-content: center;
  margin-top: 55px;
`